/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Milestone_LineInputs */

const en_us2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every one of them counted.`)
};

const pt_br2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada um deles contou.`)
};

const es_419_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada uno de ellos contó.`)
};

const pt_pt2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada um deles contou.`)
};

const fr_fr2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chacune a compté.`)
};

const de_de2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes einzelne hat gezählt.`)
};

const it_it2_share_milestone_line = /** @type {(inputs: Share_Milestone_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ognuno di loro ha contato.`)
};

/**
* | output |
* | --- |
* | "Every one of them counted." |
*
* @param {Share_Milestone_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_milestone_line = /** @type {((inputs?: Share_Milestone_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Milestone_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_milestone_line(inputs)
	if (locale === "es-419") return es_419_share_milestone_line(inputs)
	if (locale === "pt-PT") return pt_pt2_share_milestone_line(inputs)
	if (locale === "fr-FR") return fr_fr2_share_milestone_line(inputs)
	if (locale === "de-DE") return de_de2_share_milestone_line(inputs)
	if (locale === "it-IT") return it_it2_share_milestone_line(inputs)
	return en_us2_share_milestone_line(inputs)
});
export { share_milestone_line as "share.milestone_line" }